<template>
  <div class="mine">
    <div class="mineT">
      <div class="mineTM">
        <img :src="userinfo.head"  alt class="mineTMimg"/>
        <div class="mineTME">
          <h4>{{userinfo.nickName}}</h4>
          <!-- <p>
            <img src="static/images/vip.png"  alt/>
            钻石
          </p> -->
          <router-link to="/login"><p v-if="userinfo.phoneNumber == ''">绑定电话号码</p></router-link>
          <p v-if="userinfo.phoneNumber && userinfo.shopowner == 0">{{userinfo.phoneNumber.substr(0, 3) + '****' + userinfo.phoneNumber.substr(7)}}</p>
          <p v-if="userinfo.shopowner == 1">{{userinfo.shopName}}</p>
        </div>
      </div>
      <ul class="mineTS">
        <li>
          <h4>{{userinfo.amounts}}</h4>
          <p>余额(￥)</p>
        </li>
        <li>
          <h4>{{userinfo.integrals}}</h4>
          <p>积分</p>
        </li>
        <li>
          <h4>{{userinfo.boxs}}</h4>
          <p>包厢</p>
        </li>
      </ul>
    </div>
    <ul class="mineB">
      <li>
        <a @click="route(1)" class="mineBa">
          <div class="mineBE" >
            <img src="static/images/mine1.png"  alt/>
            <p>订单记录</p>
          </div>
          <img src="static/images/right.png"  alt class="mineBimg"/>
        </a>
      </li>
      <li>
        <a @click="route(2)" class="mineBa">
          <div class="mineBE"  >
            <img src="static/images/mine2.png"  alt/>
            <p>余额记录</p>
          </div>
          <img src="static/images/right.png"  alt class="mineBimg"/>
          </a>
      </li>
      <li>
        <a class="mineBa" @click="route(3)">
          <div class="mineBE" >
            <img src="static/images/mine3.png"  alt/>
            <p>积分记录</p>
          </div>
          <img src="static/images/right.png"  alt class="mineBimg"/>
        </a>
      </li>
      <li>
        <a @click="route(4)" class="mineBa">
          <div class="mineBE" >
            <img src="static/images/mine4.png"  alt/>
            <p>积分兑换记录</p>
          </div>
          <img src="static/images/right.png"  alt class="mineBimg"/>
        </a>
      </li>
      <li v-show="userinfo.shopowner == 1">
        <a @click="route(5)" class="mineBa">
          <div class="mineBE">
            <img src="static/images/mine5.png"  alt/>
            <p>门店数据</p>
          </div>
          <img src="static/images/right.png"  alt class="mineBimg"/>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog } from 'vant';

import {getTestToken, getCodeByWx} from "../api/api"
export default {
  name: 'mine',
  data () {
    return {
      userinfo: ''
    }
  },
  mounted() {
    const data = sessionStorage.getItem("userinfo")
    var wxopenid = sessionStorage.getItem("wxopenid");
    // console.log('sessionStorage userInfo=' + data)
    // console.log('wxopenid=' + wxopenid)
    if (data && wxopenid) {
      this.userinfo = JSON.parse(data)
      this.$forceUpdate()
    }else {
      // this.testToken()
      this.getCodeByWx()
    }
    // var access_code = this.getQueryString("code");
    // console.log(access_code)
  },
  methods: {
    // 登录接口
    testToken() {
      getTestToken(this, {code: this.code}).then(res => {
        if(res.code == 200) {
            sessionStorage.setItem("obdtk", res.data.obdtk);
            sessionStorage.setItem("userinfo", JSON.stringify(res.data.userInfo));
            this.userinfo = res.data.userInfo
        }
      })
    },
    // 登录接口
    getCodeByWx() {
      var wxopenid = sessionStorage.getItem("wxopenid");
      var access_code = this.getQueryString("code");
      // console.log('openId=' + wxopenid + ",code=" + access_code)
      if (wxopenid =='' || wxopenid == null || wxopenid=='null') {
        if (access_code) {
            getCodeByWx(this, {code: access_code}).then(res => {
            // console.log('userInfo' + JSON.stringify(res.data))
            if(res.code == 200) {
                sessionStorage.setItem("obdtk", res.data.obdtk);
                sessionStorage.setItem("userinfo", JSON.stringify(res.data.userInfo));
                this.userinfo = res.data.userInfo
                if (res.data.userInfo.openid) {
                  sessionStorage.setItem("wxopenid", res.data.userInfo.openid);
	  	            wxopenid = res.data.userInfo.openid;
                }
            }
          })
        }
      }
    },
    getQueryString: function (name) {
        let url  = window.location.href
        // let url = 'https://wap.xiguatrace.cn/?code=001wHj0w3PkPYW24Pg2w34ZF9q0wHj0d&state=1#/'
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
        /**
     *添加cookie
      */
    addcookie: function (name, value, expireHours) {
        var cookieString = name + "=" + escape(value) + "; path=/";
        //判断是否设置过期时间
        if (expireHours > 0) {
            var date = new Date();
            date.setTime(date.getTime + expireHours * 3600 * 1000);
            cookieString = cookieString + "; expire=" + date.toGMTString();
        }
        document.cookie = cookieString;
    },
    /**
     * 获取cookie
     */
    getcookie: function (name) {
        var strcookie = document.cookie;
        var arrcookie = strcookie.split("; ");
        for (var i = 0; i < arrcookie.length; i++) {
            var arr = arrcookie[i].split("=");
            if (arr[0] == name) return decodeURIComponent(arr[1]); //增加对特殊字符的解析
        }
        return "";
    },
    route (e) {
       if (!this.userinfo.phoneNumber) {
          this.tips()
          return 
       }
      switch(e){
        case 1:
          this.$router.push("/orderList")
          break
        case 2:
          this.$router.push("/balance")
          break
        case 3:
          this.$router.push("/integral")
          break
        case 4:
          this.$router.push("/exchange")
          break
        case 5:
          this.$router.push("/record")
          break
        default:
          //这里是没有找到对应的值处理
          break
      } 
    },
    tips () {
      Dialog.confirm({
        title: '提示',
        message: '您当前还未绑定手机号码，请先绑定'
      }).then(() => {
        this.$router.push("/login")
      }).catch(() => {
        // on cancel
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  

</style>



// WEBPACK FOOTER //
// src/components/mine.vue